import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { propArrayShape, propArrayStr, propBool, propFunc, propNumber, propShape, } from '../../../../helpers/custom-prop-types';
import { useSlideSearchCommonSelect } from '../../../../helpers/use/proffit_search/common/useSlideSearchSelect';
import { useSlideSearchSlideView } from '../../../../helpers/use/proffit_search/one/useSlideSearchSlideView';
import SlideViewerRightComponent from '../../../Ui/SlideViewer/RightComponent/SlideViewerRightComponent';
import SlideViewerBase from '../../../Ui/SlideViewer/SlideViewerBase';
const SlideSearchSlideViewer = (props) => {
    const { changeCurrentSlide, changePage, defaultImageIndexMap, defaultSlideIndex, enableDomains, folders, isEnableKeyControl, isFree, noShareMemberOptionsMessage, onChangeSelectSlide: _onChangeSelectSlide, onClickLockItem, onClickPptx, onClickSaveFolder, onLoadShareMemberOptions, onSubmitCreateFolder, onSubmitShare, profile, selectMap, selectSlides, slides, unit, } = props;
    // スライダーの表示の制御
    const { changeImageIndexMap, changeSlideListIndex, containerId, imageIndex, imageIndexMap, onClickImage, pageDownSlide, pageUpSlide, scrollingRef, setSliderRef, showPageDown, showPageUp, slide, slideListIndex, slideScrollTo, } = useSlideSearchSlideView.useSlideSearchOneSlideView({
        changeCurrentSlide,
        changePage,
        defaultImageIndexMap,
        defaultSlideIndex,
        isEnableKeyControl,
        slides,
    });
    const targetSlides = useMemo(() => {
        if (selectSlides.length > 0) {
            return selectSlides;
        }
        const targetAccess = imageIndexMap[slideListIndex] || 0;
        const targetPage = slide.pages[targetAccess] || slide.pages[0];
        return [targetPage];
    }, [selectSlides, slide, imageIndexMap, slideListIndex]);
    const { isBlockDownload, isBlockShare, isNotReadyPptx } = useSlideSearchCommonSelect.useSlideSearchCommonAllowAction(targetSlides);
    const onChangeSelectSlide = useCallback((e, model) => {
        const { dataset: { unit: unitValue }, } = e.currentTarget;
        _onChangeSelectSlide(e.currentTarget.value, {
            blockDownload: model.blockDownload,
            blockShare: model.blockShare,
            canDownload: model.canDownload,
            slideSearchSlidePageUuid: model.slideSearchSlidePageUuid,
            slideSearchSlideUuid: model.slideSearchSlideUuid,
        }, unitValue, e.currentTarget.checked);
    }, [_onChangeSelectSlide]);
    return (_jsx(SlideViewerBase, { canCheckOfLeftSlideItems: true, changeCurrentSlide: changeCurrentSlide, changeImageIndexMap: changeImageIndexMap, changeSlideListIndex: changeSlideListIndex, className: 'proffit_search_slide_viewer', containerId: containerId, imageIndex: imageIndex, imageIndexMap: imageIndexMap, onChangeSelectSlide: onChangeSelectSlide, onClickImage: onClickImage, pageDownSlide: pageDownSlide, pageUpSlide: pageUpSlide, rightComponent: _jsx(SlideViewerRightComponent, { className: '', enableDomains: enableDomains, folders: folders, isBlockDownload: isBlockDownload, isBlockShare: isBlockShare, isFree: isFree, isNotReadyPptx: isNotReadyPptx, noShareMemberOptionsMessage: noShareMemberOptionsMessage, onClickLockItem: onClickLockItem, onClickPptx: onClickPptx, onClickSaveFolder: onClickSaveFolder, onLoadShareMemberOptions: onLoadShareMemberOptions, onSubmitCreateFolder: onSubmitCreateFolder, onSubmitShare: onSubmitShare, profile: profile, selectSlides: targetSlides }), scrollingRef: scrollingRef, selectMap: selectMap, setSliderRef: setSliderRef, showPageDown: showPageDown, showPageUp: showPageUp, slide: slide, slideListIndex: slideListIndex, slides: slides, slideScrollTo: slideScrollTo, unit: unit }));
};
SlideSearchSlideViewer.propTypes = {
    changeCurrentSlide: propFunc().isRequired,
    changePage: propFunc().isRequired,
    defaultImageIndexMap: propShape().isRequired,
    defaultSlideIndex: propNumber().isRequired,
    enableDomains: propArrayStr().isRequired,
    folders: propArrayShape().isRequired,
    isEnableKeyControl: propBool().isRequired,
    isFree: propBool().isRequired,
    noShareMemberOptionsMessage: propFunc().isRequired,
    onChangeSelectSlide: propFunc().isRequired,
    onClickLockItem: propFunc().isRequired,
    onClickPptx: propFunc().isRequired,
    onClickSaveFolder: propFunc().isRequired,
    onLoadShareMemberOptions: propFunc().isRequired,
    onSubmitCreateFolder: propFunc().isRequired,
    onSubmitShare: propFunc().isRequired,
    profile: propShape().isRequired,
    selectMap: propShape().isRequired,
    selectSlides: propArrayShape().isRequired,
    slides: propArrayShape().isRequired,
    unit: propShape().isRequired,
};
export default SlideSearchSlideViewer;
